module.exports = __webpack_public_path__ + "img/app-contacts.63f59596.png";